import { Role, RolesInfo } from './types';

export enum RolesActionTypes {
  FETCH_ROLES_INFO_SUCCESS = '@@roles/FETCH_ROLES_INFO',
  FETCH_ROLES_INFO_ERROR = '@@roles/FETCH_ROLES_INFO_ERROR',

  FETCH_ROLES_SUCCESS = '@@roles/FETCH_ROLES',
  FETCH_ROLES_ERROR = '@@roles/FETCH_ROLES_ERROR',

  POST_ROLE_SUCCESS = '@@roles/POST_ROLE_SUCCESS',
  POST_ROLE_ERROR = '@@roles/POST_ROLE_ERROR',

  DELETE_ROLE_SUCCESS = '@@roles/DELETE_ROLE_SUCCESS',
  DELETE_ROLE_ERROR = '@@roles/DELETE_ROLE_ERROR',

  PUT_ROLE_SUCCESS = '@@roles/PUT_ROLE_SUCCESS',
  PUT_ROLE_ERROR = '@@roles/PUT_ROLE_ERROR',

  CLEAR_ERROR = '@@roles/CLEAR_ERROR'
}

interface IFetchRolesInfoSuccess {
  type: typeof RolesActionTypes.FETCH_ROLES_INFO_SUCCESS;
  rolesInfo: RolesInfo;
}

interface IFetchRolesInfoError {
  type: typeof RolesActionTypes.FETCH_ROLES_INFO_ERROR;
  status: number;
}

interface IFetchRolesSuccess {
  type: typeof RolesActionTypes.FETCH_ROLES_SUCCESS;
  roles: Role[];
}

interface IFetchRolesError {
  type: typeof RolesActionTypes.FETCH_ROLES_ERROR;
  status: number;
}

interface IPostRoleSuccess {
  type: typeof RolesActionTypes.POST_ROLE_SUCCESS;
  role: Role;
  status: number;
}

interface IPostRoleError {
  type: typeof RolesActionTypes.POST_ROLE_ERROR;
  status: number;
}

interface IDeleteRoleSuccess {
  type: typeof RolesActionTypes.DELETE_ROLE_SUCCESS;
  role: Role;
  status: number;
}

interface IDeleteRoleError {
  type: typeof RolesActionTypes.DELETE_ROLE_ERROR;
  status: number;
}

interface IPutRoleSuccess {
  type: typeof RolesActionTypes.PUT_ROLE_SUCCESS;
  role: Role;
  status: number;
}

interface IPutRoleError {
  type: typeof RolesActionTypes.PUT_ROLE_ERROR;
  status: number;
}

interface IClearError {
  type: typeof RolesActionTypes.CLEAR_ERROR;
}

export type RolesActions =
  | IFetchRolesInfoSuccess
  | IFetchRolesInfoError

  | IFetchRolesSuccess
  | IFetchRolesError

  | IPostRoleSuccess
  | IPostRoleError

  | IDeleteRoleSuccess
  | IDeleteRoleError

  | IPutRoleSuccess
  | IPutRoleError

  | IClearError
;
